import { render, staticRenderFns } from "./TouristStat.vue?vue&type=template&id=588b4b88&scoped=true&"
import script from "./TouristStat.vue?vue&type=script&lang=js&"
export * from "./TouristStat.vue?vue&type=script&lang=js&"
import style0 from "./TouristStat.vue?vue&type=style&index=0&id=588b4b88&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "588b4b88",
  null
  
)

export default component.exports